<template>
  <div class="help-modal">
    <b-modal
      hide-header
      lazy
      no-fade
      v-model="help.confirm.shown"
      :ok-title="help.confirm.okButtonTitle"
      :ok-only="help.confirm.isOkOnly"
      :no-close-on-backdrop="help.confirm.isOkOnly"
      :no-close-on-esc="help.confirm.isOkOnly"
      ok-variant="v2_primary"
      cancel-variant="v2_white"
      class="v2_color_black v2_font_size_18"
      @ok="ok"
      @cancel="cancel"
    >
      <div v-if="help.confirm.text === help.confirm.SURVEY_SUBMIT">
        <p>
          Submit this Study?
        </p>
        <p>
          This will add your responses to the database, as part of the aggregate
          data that all users can view.
        </p>
        <p>
          The aggregate data will be anonymized so that there is no way for any
          other user to identify your individual responses.
        </p>
        <p>
          You will not be able to edit this Study once you submit it.
        </p>
      </div>
      <div v-else>
        <span v-if="help.confirm.isHtml" v-html="getSanitizedHtml()" />
        <span v-else>
          {{ help.confirm.text }}
        </span>
      </div>
    </b-modal>
  </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Help from '@/providers/Help.js';
import sanitizeHtml from 'sanitize-html';

export default {
  name: 'helpConfirmModal',
  data() {
    return {
      help: Help,
    };
  },
  methods: {
    ok() {
      this.help.confirm.ok();
    },
    cancel() {
      this.help.confirm.cancel();
    },
    getSanitizedHtml: function () {
      return sanitizeHtml(this.help.confirm.text);
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss"></style>
